import { defineMessages } from 'react-intl';

export const filteredRatesEmptyStateMessages = defineMessages({
  title: {
    defaultMessage: 'No freight rates match your search',
    id: 'DSKcxk',
    description: 'Title of the empty state when the active freight rate filters produce no results',
  },
  subtitle: {
    defaultMessage: 'Try adjusting your keywords or clearing filters to browse all available rates.',
    id: 'ZiB4St',
    description: 'Subtitle of the empty state when the active freight rate filters produce no results',
  },
  clearSelection: {
    defaultMessage: 'Clear Selection',
    id: 'Jwk0O7',
    description: 'Link that clears the active freight rate filters from the empty state',
  },
});
